module.exports = __webpack_public_path__ + "static/img/zo_tx.b985dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geren/qietu/zo_tx.png
// module id = YXWD
// module chunks = 36